import React, { useState, useEffect } from 'react';
import { useRef } from 'react';
import axios from 'axios';
import Paper from '@mui/material/Paper';
import SearchIcon from '@mui/icons-material/Search';
import * as XLSX from 'xlsx';
import { fetchData, updateData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { IconButton } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import FeedIcon from '@mui/icons-material/Feed';
import Select from 'react-select'; // Import react-select
import CopyrightIcon from '@mui/icons-material/Copyright';
import CircularProgress from '@mui/material/CircularProgress';
import { Box } from '@mui/material';
import CreateIcon from '@mui/icons-material/Create';
import AddIcon from '@mui/icons-material/Add';
import InfoIcon from '@mui/icons-material/Info';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import { Tooltip } from '@mui/material';
import {
    Checkbox, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow, TableSortLabel, TablePagination, TableFooter
} from '@mui/material';
import Modal from '@mui/material/Modal';
import { Button } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useLocation, Link } from 'react-router-dom';
import AsyncSelect from 'react-select/async';


function CreditorDebitorReport() {
    const { isAuthenticated, companyId, branchId, permissions, token, logout } = useAuth();
    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        setFromDate(getFormattedStartDate());
        setToDate(getFormattedCurrentDate());
        // Token is not expired, fetch data
        fetchTableData();

    }, [isAuthenticated, companyId, branchId, permissions, token, logout]);
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');

    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [isFocused, setIsFocused] = useState(false);

    const hasCreateMasterPermission = permissions.includes('Create Transaction');
    const hasEditMasterPermission = permissions.includes('Edit Transaction');
    const hasDeleteMasterPermission = permissions.includes('Delete Transaction');
    const hasReadReportPermission = permissions.includes('Read Reports');


    // Function to format date as dd/mm/yyyy
    const getCurrentDate = () => {
        const today = new Date();
        const day = String(today.getDate()).padStart(2, '0'); // Add leading zero
        const month = String(today.getMonth() + 1).padStart(2, '0'); // Add leading zero, months are 0-indexed
        const year = today.getFullYear();

        return `${day}/${month}/${year}`;
    };

    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };

    const getFormattedStartDate = () => {
        const monthStartDate = new Date();
        monthStartDate.setDate(1);
        return monthStartDate.toISOString().split('T')[0];
    };


    const handleFromDateChange = (e) => {
        const selectedDate = e.target.value;
        setFromDate(selectedDate);
    };

    const handleToDateChange = (e) => {
        const selectedDate = e.target.value;
        setToDate(selectedDate);
    };

    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    //handle search
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    //search
    const filteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return new Date(dateString).toLocaleDateString('en-GB', options);
    };

    const [totalcls, setTotalcls] = useState(0);
    useEffect(() => {
        let totalcls = 0;

        data.forEach(item => {
            totalcls += item.amount;

        });
        setTotalcls(totalcls);
    }, [data]);

    const [debitororcreditorType, setdebitororcreditor] = useState("1");
    const handlesetdebitororcreditorTypeChange = (event) => {
        setdebitororcreditor(event.target.value);
    };

    const [loading, setLoading] = useState(false);

    const fetchTableData = async () => {
        if (hasReadReportPermission) {
            setData([]);
            setLoading(true);
            const branchId = 0;
            try {
                
                 const response = await fetchData('ReportApi', `/CreditorDebitor/${toDate}/${companyId}/${branchId}/${debitororcreditorType}`, token);
                if (response.responseCode === '1111') {
                    setData(response.response_data);
                }
            } catch (error) {
                console.error('Error fetching Stock Details:', error);
            }
            finally {
                setLoading(false); // Hide loading screen
            }
        }
    };

    const handleExportExcel = () => {
        const wb = XLSX.utils.book_new();
    
        // Format header caption based on debitororcreditorType
        const headerCaption = `${debitororcreditorType === "1" ? "Creditors List" : "Debitors List"}:  To : ${formatDate(toDate)}`;
        const allDataSheet = [];
        allDataSheet.push([headerCaption]);  // Add header caption as the first row
    
        // Define column headers
        const headerRow = ['Name', 'Contact No', 'Amount'];
        allDataSheet.push(headerRow);  // Add header row
    
        // Add data rows
        filteredData.forEach((rowData) => {
            const dataRow = [
                rowData.name,
                rowData.Contactno,
                parseFloat(rowData.amount.toFixed(2)),  // Format amount to 2 decimal places
            ];
            allDataSheet.push(dataRow);
        });
    
        // Calculate total amount
        const totalAmount = filteredData.reduce((sum, rowData) => sum + parseFloat(rowData.amount), 0);
    
        // Convert allDataSheet array to a worksheet
        const allDataWs = XLSX.utils.aoa_to_sheet(allDataSheet);
    
        // Append the sheet to the workbook
        XLSX.utils.book_append_sheet(wb, allDataWs, debitororcreditorType === "1" ? "Creditors List" : "Debitors List");
    
        // Write the workbook to a file
        XLSX.writeFile(wb, `${debitororcreditorType === "1" ? "Creditors List" : "Debitors List"}.xlsx`);

    };
    


    return (

        <div className="w-full  mx-auto" style={{ width: '95%', marginTop: '10px' }}>
            <h6
                className="block uppercase tracking-wide text-black productHead flex-grow linkcolor"
                style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black', fontWeight: 'bolder' }}
            >
                {debitororcreditorType === "1" ? "Creditors List" : "Debitors List"}
            </h6>

            {loading && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 9999
                }}>
                    <div>
                        <CircularProgress style={{ color: 'white' }} />
                        <span style={{ color: 'white', marginTop: '10px', display: 'block' }}>Loading...</span>
                    </div>
                </div>
            )}
            <div style={{
                width: '100%',
                marginBottom: '2',
                display: 'flex',
                flexWrap: 'nowrap',
                justifyContent: 'flex-end',
                alignItems: 'center',
                paddingRight: '20px',
                position: 'relative',
                marginTop: '-2%'
            }}>

                <div className="w-full mb-2 flex" style={{ marginTop: '10px', justifyContent: 'flex-end' }}> {/* Align this inner container to the right */}

                    <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                            To Date
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            type="date" value={toDate} onChange={handleToDateChange}
                            style={{ marginTop: '-10px', width: '100%' }}
                        />
                    </div>
                    <div className="flex justify-end items-center">
                        <label className="block uppercase tracking-wide text-gray-700 font-bold mr-0" style={{ marginLeft: '12px' }}>
                            <input
                                type="radio"
                                name="debitororcreditorType"
                                value="1"
                                checked={debitororcreditorType === "1"} // This will check the "Creditor" radio button by default
                                onChange={handlesetdebitororcreditorTypeChange}
                            />
                            <span style={{ color: 'blue', fontSize: '12px' }}>Creditors</span>
                        </label>
                        <label className="block uppercase tracking-wide text-gray-700 font-bold mr-0" style={{ marginLeft: '12px' }}>
                            <input
                                type="radio"
                                name="debitororcreditorType"
                                value="2"
                                checked={debitororcreditorType === "2"} // This will check the "Debitor" radio button if it's selected
                                onChange={handlesetdebitororcreditorTypeChange}
                            />
                            <span style={{ color: 'brown', fontSize: '12px' }}>Debitors</span>
                        </label>
                    </div>
                    <Button
                        style={{
                            background: 'linear-gradient(to right, #C7FFD8,#C7FFD8)',
                            borderRadius: '50px',
                            padding: '10px 20px',
                            color: '#0F0F0F',
                            fontWeight: 'bolder',
                            textTransform: 'none',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                            maxHeight: '35px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginLeft: '15px',
                            marginTop: '15px'
                        }}
                        onClick={fetchTableData}
                        className="linkcolor"
                    >
                        <span>Refresh</span>
                    </Button>
                    <Button
                        style={{
                            background: 'linear-gradient(to right, #98DED9,#98DED9)',
                            borderRadius: '50px',
                            padding: '10px 20px',
                            color: '#0F0F0F',
                            fontWeight: 'bolder',
                            textTransform: 'none',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                            maxHeight: '35px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginLeft: '10px',
                            marginTop: '15px'
                        }}
                        onClick={handleExportExcel}
                        className="linkcolor"
                    >
                        <span>Excel</span>
                    </Button>
                </div>
                {/* Watermark at the bottom-right corner */}


            </div>

            <div className="watermark" style={{ position: 'absolute', bottom: '10px', right: '20px' }}>
                <CopyrightIcon />
                <b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
            </div>
            <div
                className="w-full mb-5 flex"
                style={{ maxHeight: '550px', overflowY: 'auto', marginTop: '7px' }}
            >
                <TableContainer component={Paper}>
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: '#1F2544', width: '2500px' }}>
                            <TableRow sx={{ whiteSpace: 'nowrap' }}>
                                {[

                                    'Name',
                                    'Contact',
                                    'Amount',

                                ].map((header) => (
                                    <TableCell
                                        key={header}
                                        sx={{
                                            borderBottom: '1px solid #F5F5F5',
                                            fontWeight: 'bolder',
                                            fontSize: '14px',
                                            padding: '7px',
                                            color: 'whitesmoke',
                                            backgroundColor: '#1F2544',
                                        }}
                                    >
                                        {header}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>


                        <TableBody sx={{ backgroundColor: 'whitesmoke' }}>
                            {filteredData.map((data, index) => {
                                const isTotalRow = data.name === "Total"; // Check if the name is "Total"

                                return (
                                    <TableRow
                                        key={data.id}
                                        className="highlighted-row"
                                        sx={{
                                            padding: '5px',
                                            height: '42px',
                                            backgroundColor: isTotalRow ? '#C2D9FF' : 'transparent',
                                        }}
                                    >
                                        {[data.name, data.Contactno, data.amount].map((value, i) => (
                                            <TableCell
                                                key={i}
                                                sx={{
                                                    borderBottom: '1px solid black',
                                                    color: isTotalRow ? '#0802A3' : 'black',
                                                    fontWeight: isTotalRow ? 'bold' : 'bolder',
                                                    padding: '2px',
                                                    fontSize: '14px',
                                                    textAlign: i >= 3 ? 'center' : 'left',
                                                }}
                                            >
                                                {value}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                );
                            })}
                        </TableBody>

                    </Table>
                </TableContainer>

            </div>

        </div>
    );
}

export default CreditorDebitorReport;
